import { ResultMessageType } from './result-message.type';
import { IResult } from './result.interface';

export function wrapResult<T>(message: ResultMessageType, data: T): IResult<T> {
  return {
    message,
    data,
  };
}
